module.exports = __webpack_public_path__ + "static/media/keep-it-dirty.ff9c04f0.png";